// extracted by mini-css-extract-plugin
export default {"page_wrapper":"Exercises_page_wrapper__n-9G3","header_wrapper":"Exercises_header_wrapper__Z73+0","keyword":"Exercises_keyword__56tQE","title":"Exercises_title__s0n00"};